import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTranslation } from '@pancakeswap/localization'
import { MoonIcon, SunIcon } from 'lucide-react'
import { useTheme } from 'next-themes'

export const ThemeSelector = () => {
  const { t } = useTranslation()
  const { theme, setTheme } = useTheme()

  return (
    <Tabs value={theme} onValueChange={setTheme}>
      <TabsList>
        <TabsTrigger value={'system'} className={'w-16'}>
          {t('Auto')}
        </TabsTrigger>
        <TabsTrigger value={'light'} className={'w-16'}>
          <SunIcon />
        </TabsTrigger>
        <TabsTrigger value={'dark'} className={'w-16'}>
          <MoonIcon />
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
